import { Box, Button, ButtonGroup, TextButton } from '@zillow/constellation-10';

import {
  SKIP_DESCRIBE_YOU_QUESTION_EVENT_ID,
  SKIP_NAME_QUESTION_EVENT_ID,
  SKIP_UNIT_COUNT_QUESTION_EVENT_ID,
  SUBMIT_DESCRIBE_YOU_QUESTION_EVENT_ID,
  SUBMIT_NAME_QUESTION_EVENT_ID,
  SUBMIT_UNIT_COUNT_QUESTION_EVENT_ID,
} from '../../../../analytics/events/userOnboarding';
import { STEPS } from '../types';

import type { FC } from 'react';
import type { StepType } from '../types';

const SKIP_EVENT_ID: Partial<Record<StepType, string>> = {
  [STEPS.NAME]: SKIP_NAME_QUESTION_EVENT_ID,
  [STEPS.PROFILE_TYPE]: SKIP_DESCRIBE_YOU_QUESTION_EVENT_ID,
  [STEPS.PROPERTY_COUNT]: SKIP_UNIT_COUNT_QUESTION_EVENT_ID,
};

const CONTINUE_EVENT_ID: Partial<Record<StepType, string>> = {
  [STEPS.NAME]: SUBMIT_NAME_QUESTION_EVENT_ID,
  [STEPS.PROFILE_TYPE]: SUBMIT_DESCRIBE_YOU_QUESTION_EVENT_ID,
  [STEPS.PROPERTY_COUNT]: SUBMIT_UNIT_COUNT_QUESTION_EVENT_ID,
};

type Props = {
  currentStep: StepType;
  currentStepIndex: number;
  isSaving: boolean;
  isSubmitDisabled: boolean;
  isNewUser: boolean;
  onBack: () => void;
  onContinue: () => void;
  onSkip: () => void;
};

export const OnboardingButtons: FC<Props> = ({
  currentStep,
  currentStepIndex,
  isSaving,
  isSubmitDisabled,
  isNewUser,
  onBack,
  onContinue,
  onSkip,
}) => {
  const showBack = currentStepIndex > 0 && currentStep !== STEPS.MULTIPLEX_UNITS_ADDED && currentStep !== STEPS.THANKS;
  const showSkip =
    isNewUser &&
    currentStep !== STEPS.PROPERTY_CONFIRMATION &&
    currentStep !== STEPS.MULTIPLEX_UNIT_ENTRY &&
    currentStep !== STEPS.MULTIPLEX_UNITS_ADDED &&
    currentStep !== STEPS.THANKS;

  return (
    <ButtonGroup
      aria-label="Onboarding navigation"
      css={{
        display: 'flex',
        width: '100%',
        justifyContent: showBack ? 'space-between' : 'flex-end',
      }}
    >
      {showBack && (
        <TextButton tone="neutral" css={{ paddingLeft: '0' }} onClick={onBack} disabled={isSaving}>
          Back
        </TextButton>
      )}
      <Box css={{ display: 'flex', gap: '200', alignItems: 'center' }}>
        {showSkip && (
          <TextButton tone="neutral" onClick={onSkip} disabled={isSaving} data-eventid={SKIP_EVENT_ID[currentStep]}>
            Skip
          </TextButton>
        )}
        <Button
          tone="brand"
          emphasis="filled"
          onClick={onContinue}
          disabled={isSaving || isSubmitDisabled}
          data-eventid={CONTINUE_EVENT_ID[currentStep]}
        >
          {currentStep === STEPS.PROPERTY_CONFIRMATION
            ? 'Confirm'
            : currentStep === STEPS.MULTIPLEX_UNIT_ENTRY
              ? 'Save & continue'
              : currentStep === STEPS.MULTIPLEX_UNITS_ADDED
                ? 'Add listing details'
                : currentStep === STEPS.THANKS
                  ? 'Done'
                  : 'Continue'}
        </Button>
      </Box>
    </ButtonGroup>
  );
};
